module.exports = __webpack_public_path__ + "img/quoteEnd.e941dd52.svg";